
























































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import ImportData from '@/components/ImportData.vue'
import ExportData from '@/components/ExportData.vue'
import ClearUpHistoryData from '@/components/ClearUpHistoryData.vue'

@Component({
  components: {
    ImportData,
    ExportData,
    ClearUpHistoryData,
  },
})
export default class Settings extends Vue {
  @Action('TOGGLE_THEME') private actionTheme!: (payload: { currentTheme: string }) => void
  @Action('TOGGLE_LANG') private actionLang!: (payload: { currentLang: string }) => void
  @Action('SET_MAX_RECONNECT_TIMES') private actionMaxReconnectTimes!: (payload: { maxReconnectTimes: number }) => void
  @Action('TOGGLE_AUTO_RESUB') private actionAutoResub!: (payload: { autoResub: boolean }) => void
  @Action('TOGGLE_AUTO_SCROLL') private actionAutoScroll!: (payload: { autoScroll: boolean }) => void
  @Action('SET_AUTO_SCROLL_INTERVAL') private actionAutoScrollInterval!: (payload: {
    autoScrollInterval: number
  }) => void
  @Action('TOGGLE_MULTI_TOPICS') private actionToggleMultiTopics!: (payload: { multiTopics: boolean }) => void
  @Action('TOGGLE_TOPIC_WHITESPACE_DETECTION') private actionToggleTopicWhitespaceDetection!: (payload: {
    topicWhitespaceDetection: boolean
  }) => void
  @Getter('currentTheme') private currentTheme!: 'light' | 'dark' | 'night'
  @Getter('currentLang') private currentLang!: Language
  @Getter('maxReconnectTimes') private maxReconnectTimes!: number
  @Getter('autoResub') private autoResub!: boolean
  @Getter('autoScroll') private autoScroll!: boolean
  @Getter('autoScrollInterval') private autoScrollInterval!: number
  @Getter('multiTopics') private multiTopics!: boolean
  @Getter('topicWhitespaceDetection') private topicWhitespaceDetection!: boolean

  private langOptions: Options[] = [
    { label: '简体中文', value: 'zh' },
    { label: 'English', value: 'en' },
    { label: '日本語', value: 'ja' },
  ]
  private themeOptions: Options[] = [
    { label: 'Light', value: 'light' },
    { label: 'Dark', value: 'dark' },
    { label: 'Night', value: 'night' },
  ]

  private showImportData = false
  private showExportData = false
  private showHistoryData = false

  private handleSelectChange(type: 'lang' | 'theme', value: string | number | boolean): void {
    if (type === 'theme') {
      this.actionTheme({ currentTheme: value as string })
      window.document.body.setAttribute('class', value as string)
    } else if (type === 'lang') {
      this.actionLang({ currentLang: value as string })
      document.documentElement.setAttribute('lang', value as string)
      this.$i18n.locale = value as string
    }
  }

  private handleAutoResubSwitchChange(value: boolean) {
    this.actionAutoResub({ autoResub: value })
  }

  private handleAutoScrollSwitchChange(value: boolean) {
    this.actionAutoScroll({ autoScroll: value })
  }

  private handleMultiTopicsSwitchChange(value: boolean) {
    this.actionToggleMultiTopics({ multiTopics: value })
  }

  private handleTopicWhitespaceDetectionChange(value: boolean) {
    this.actionToggleTopicWhitespaceDetection({ topicWhitespaceDetection: value })
  }

  private handleInputChage(value: number) {
    this.actionMaxReconnectTimes({ maxReconnectTimes: value })
  }

  private handleAutoScrollIntervalChange(value: number) {
    this.actionAutoScrollInterval({ autoScrollInterval: value })
  }

  private handleImportData() {
    this.showImportData = true
  }

  private handleExportData() {
    this.showExportData = true
  }

  private handleCleanupHistoryData() {
    this.showHistoryData = true
  }
}
